import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';

const api = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/organizational-legal-forms`,
  tagTypes: ['OrganizationalLegalForm'],
  endpoints: builder => ({
    getOrganizationalLegalForms: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['OrganizationalLegalForm'],
    }),
    getOrganizationalLegalFormsI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['OrganizationalLegalForm'],
    }),
    getOrganizationalLegalFormById: builder.query<ReferenceBook, string>({
      query: id => ({
        url: `/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [
        { type: 'OrganizationalLegalForm', id },
      ],
    }),
    createOrganizationalLegalForm: builder.mutation<
      string,
      Pick<ReferenceBook, 'value'>
    >({
      query: data => ({
        url: '',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['OrganizationalLegalForm'],
    }),
    updateOrganizationalLegalForm: builder.mutation<
      void,
      { id: string; data: Omit<ReferenceBook, 'id'> }
    >({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'OrganizationalLegalForm', id },
        'OrganizationalLegalForm',
      ],
    }),
  }),
});

export const organizationalLegalFormsApi = api;

export const {
  useGetOrganizationalLegalFormsQuery,
  useGetOrganizationalLegalFormByIdQuery,
  useCreateOrganizationalLegalFormMutation,
  useUpdateOrganizationalLegalFormMutation,
} = api;

export const useGetOrganizationalLegalFormsInfiniteQuery =
  normalizeInfiniteQueryData(api.useGetOrganizationalLegalFormsIInfiniteQuery);
